import {
  UserOrganizationsListQuery,
  type UserOrganizationsListRow,
} from "@/admin/entities/organizationUsers";
import { InnerCRUD } from "@/shared/components";
import {
  getUserOrganizationsColumnsConfig,
  getUserOrganizationsTextsConfig,
  mapUserOrganizationsColumns,
} from "../../model";

interface UserOrganizationsProps {
  id?: string;
}

// Только чтение: членство проставляется/снимается через вкладку
// "Сотрудники" организации (createOrganizationUser принимает organizationId,
// не userId) — здесь просто показываем, где юзер сотрудник.
export const UserOrganizations: React.FC<UserOrganizationsProps> = ({ id }) => {
  return (
    <InnerCRUD<UserOrganizationsListRow>
      listQuery={UserOrganizationsListQuery}
      listQueryVariables={{ filter: { userId: id } }}
      getTableData={(data) => data?.organizationUsers}
      mapColumns={mapUserOrganizationsColumns}
      columns={getUserOrganizationsColumnsConfig()}
      texts={getUserOrganizationsTextsConfig()}
    />
  );
};
